"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const jsxRuntime = require("react/jsx-runtime");
const clsx = require("../../../chunks/clsx-CBkIpawf.js");
const helpers_module = require("../../../chunks/helpers.module-CyAR4a3K.js");
const spinner = "_spinner_qof2f_3";
const rotation = "_rotation_qof2f_1";
const spinnerColor = "_spinnerColor_qof2f_13";
const pop = "_pop_qof2f_1";
const styles = {
  spinner,
  rotation,
  spinnerColor,
  "spinner-small": "_spinner-small_qof2f_20",
  "spinner-large": "_spinner-large_qof2f_26",
  "fade-in": "_fade-in_qof2f_1",
  "fade-out": "_fade-out_qof2f_1",
  "shrink-width": "_shrink-width_qof2f_1",
  "slide-in-up": "_slide-in-up_qof2f_1",
  "slide-out-down": "_slide-out-down_qof2f_1",
  "appear-from-bottom": "_appear-from-bottom_qof2f_1",
  "disappear-to-bottom": "_disappear-to-bottom_qof2f_1",
  "appear-from-right": "_appear-from-right_qof2f_1",
  "dissapear-to-right": "_dissapear-to-right_qof2f_1",
  pop,
  "pop-out": "_pop-out_qof2f_1"
};
const Spinner = ({
  size = "large",
  status,
  description,
  className,
  ...props
}) => /* @__PURE__ */ jsxRuntime.jsx(
  "span",
  {
    className: clsx.clsx(styles.spinner, styles.spinnerColor, styles["spinner-" + size], className),
    role: status ? "status" : void 0,
    ...props,
    children: description && /* @__PURE__ */ jsxRuntime.jsx("span", { className: helpers_module.helpers.srOnly, children: description })
  }
);
exports.Spinner = Spinner;
